// Hook do dodawania załącznika do zgłoszenia reklamacyjnego (Panel Klienta)

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IRequest {
  id: number;
  base64: string;
  name: string;
  originalFilename: string;
}

type IResponse = ICommandResponseSuccess & {
  data?: {
    id: number;
    name: string;
    url: string | null;
    original_filename: string;
    extension: string;
  };
};

const postReturnComplaintAttachment = (data: IRequest): Promise<IResponse> =>
  axios.post(`/return-complain/requests/${data.id}/attachments`, data);

export const usePostReturnComplaintAttachment = (
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => postReturnComplaintAttachment(data), options);
